import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { UploadFileStatus } from './FileUploadModal';
import { IUploadData } from './FileUploadModalService';
import  {getLoadingPreviewIcon} from './fileTypeIconMap';
import CircleLoader from '../../circle-loader/CircleLoader';
import { UtilsService } from '@app/src/services/UtilsService';

import UploadSuccessIcon from '@app/src/assets/icons/notification-success.svg';
import UploadFailedIcon from '@app/src/assets/icons/notification-error.svg';

import './FileUploadItem.scss';

interface IProps {
  uploadData?: IUploadData;
}

class FileUploadItem extends Component<IProps> {
  getElementByStatus = ({ status, progress }: IUploadData) => {
    if (status === UploadFileStatus.PROGRESS) {
      return <CircleLoader value={progress} />;
    }

    if (status === UploadFileStatus.UPLOADED) {
      return <UploadSuccessIcon className="file-upload-item__status-icon" />;
    }

    if (status === UploadFileStatus.FAILED) {
      return (
        <>
          <FormattedMessage id="gallery.upload.failed">
            {text => <span className="file-upload-item__failed">{text}</span>}
          </FormattedMessage>
          <UploadFailedIcon className="file-upload-item__status-icon" />
        </>
      );
    }
  }

  render() {
    const { uploadData } = this.props;

    if (!uploadData) {
      return null;
    }

    return (
      <div className="file-upload-item">
          {getLoadingPreviewIcon(uploadData.fileType)}
        <div className="file-upload-item__name">{uploadData.fileName}</div>
        <div className="file-upload-item__size">
          {UtilsService.formatBytes(uploadData.fileSize)}
        </div>
        {this.getElementByStatus(uploadData)}
      </div>
    );
  }
}

export default FileUploadItem;
